import reportApi from 'api/reportApi';
import { formatTimeHandlerHrs, handleToastError } from 'helpers';
import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { ArrowDown, ArrowUp } from 'react-feather';
import { useSelector } from 'react-redux';
import { getSelectedCentre } from 'store/master';
import { getDarkMode } from 'store/settings';
const Barchart = () => {
  const selectedCentre = useSelector(getSelectedCentre);
  const isDark = useSelector(getDarkMode);
  const [barchat, setBarchat] = useState({
    label: [],
    value: [],
    percentage: 0,
  });
  const payload = {
    data: [
      {
        course: {
          status: 'ACTIVE',
          name: 'Test Intake',
          code: 'MS-P-24',
        },
        user: {},
        totalIntakeTime: 12900,
      },
      {
        course: {
          status: 'ACTIVE',
          name: 'Test Intake',
          code: 'PSLE-24-M-SEP',
        },
        user: {},
        totalIntakeTime: 1800,
      },
    ],
    totalMinutes: 14700,
    totalPercent: 0,
  };

  const [barminute, setBarMinutes] = useState();
  const disable = barchat.label?.length;
  const state = barchat.label?.length
    ? {
        labels: barchat.label,
        datasets: [
          {
            backgroundColor: '#468799',
            borderColor: 'rgb(31,120,180)',

            data: barchat.value,
          },
        ],
      }
    : {
        labels: ['course', 'course', 'course', 'course'],
        datasets: [
          {
            backgroundColor: '#c8c8c8',
            borderColor: '#c8c8c8',

            data: [40, 39, 29, 12],
          },
        ],
      };

  async function barChartdata() {
    try {
      const response = await reportApi.getBarChartValue({
        ...(selectedCentre?._id && { courseCentre: selectedCentre?._id }),
        ...((selectedCentre?.reviewContent === undefined ||
          selectedCentre?.reviewContent) && {
          reviewContent: selectedCentre?.reviewContent !== undefined,
        }),
      });
      setBarMinutes(response);
    } catch (error) {
      handleToastError(error);
    }
  }
  useEffect(() => {
    barChartdata();
  }, [selectedCentre]);

  async function barChartdetails(response) {
    try {
      const top5Data = response.data
        ?.filter((data) => data.totalIntakeTime)
        .sort((a, b) => b.totalIntakeTime - a.totalIntakeTime)
        .slice(0, 5);

      setBarchat({
        label: top5Data.map((data) => data.course.code),
        value: top5Data.map((data) => (data.totalIntakeTime / 60).toFixed(2)),
        percentage: response.totalPercent,
      });
    } catch (error) {
      handleToastError(error);
    }
  }

  useEffect(() => {
    barminute?.data && barChartdetails(barminute);
  }, [barminute]);

  return (
    <div className="barchart-learner">
      <Bar
        percentage={barchat?.percentage}
        data={state}
        options={{
          responsive: true,
          height: 150,
          width: 550,
          responsive: true,
          layout: {
            padding: 10,
          },
          legend: {
            display: false,
            position: 'right',
            labels: {
              fontSize: 5,
            },
          },
          tooltips: {
            mode: !disable ? null : 'label',
            backgroundColor: isDark ? '#243040' : '#ffffff',
            titleFontColor: isDark ? '#b4b7bd' : '#6e6b7b',
            bodyFontColor: isDark ? '#b4b7bd' : '#6e6b7b',
            borderColor: isDark ? '#344054' : '#e2e8f0',
            borderWidth: 1,
            callbacks: {
              label: (tooltipItem, data) => {
                const value =
                  data.datasets[tooltipItem.datasetIndex].data[
                    tooltipItem.index
                  ];
                return value > 1000 ? value + 'k' : value;
              },
            },
          },
          hover: {
            mode: !disable ? null : 'label',
          },

          scales: {
            xAxes: [
              {
                barThickness: 20,
                gridLines: {
                  drawOnChartArea: false,
                },
                ticks: {
                  display: !!disable,
                  fontSize: 10,
                  fontColor: isDark ? '#b4b7bd' : '#6e6b7b',
                },
              },
            ],
            yAxes: [
              {
                gridLines: {
                  drawOnChartArea: false,
                },
                ticks: {
                  beginAtZero: true,
                  fontColor: isDark ? '#b4b7bd' : '#6e6b7b',
                },
              },
            ],
          },
        }}
      />
    </div>
  );
};

export default Barchart;
